import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { watchNetwork } from "../lib/native";

/**
 * OfflineBanner — a slim, persistent bar that appears at the top of the
 * viewport whenever the device loses connectivity. The React app itself
 * keeps rendering (cached HTML/JS/CSS + PWA service worker), so users can
 * still browse their digital card, saved QR, and last-loaded data.
 *
 * On reconnect the banner disappears and any in-flight API calls resume
 * naturally via the app's axios retry logic.
 */
export default function OfflineBanner() {
  const [online, setOnline] = useState(true);
  useEffect(() => watchNetwork(setOnline), []);
  if (online) return null;
  return (
    <div
      role="status"
      data-testid="offline-banner"
      className="fixed top-0 inset-x-0 z-[9999] bg-[#EF4444] text-white text-xs font-bold px-4 py-2 flex items-center justify-center gap-2 shadow-lg"
      style={{ paddingTop: "calc(env(safe-area-inset-top) + 0.5rem)" }}
    >
      <WifiOff size={14} /> You&apos;re offline · showing cached data · will refresh when back online
    </div>
  );
}
